import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import DragPicker from 'components/picker/drag/drag_picker'
import MediaSearch from 'decorators/media_search/media_search_decorator'
import GifSearch from 'components/picker/search/gif/gif_picker_search'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import NearpodPickerOptions from '../../components/options/nearpod_picker_options'
import { normalizeGifSearchFiles } from 'helpers/pickerNormalizer'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_gif.scss'

class NearpodPickerGif extends PureComponent {

	constructor() {
		super()
		this.cancelHandler = this.cancelHandler.bind(this)
		this.saveHandler = this.saveHandler.bind(this)
	}

	cancelHandler() {
		if (this.props.gifSearchActive) {
			this.props.onMediaSearchClear('gif')
		} else {
			this.props.closeHandler()
		}
	}

	saveHandler() {
		const selectedItems = this.props.gifSearchResults.filter((data, index) => this.props.gifSearchSelected.includes(index))
		this.props.onFilesPicked(normalizeGifSearchFiles(selectedItems, 'gif'))
	}

	render() {
		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_gif_title')}</SecondaryTitle>
				<GifSearch
					onSearchConfirm={this.props.onMediaSearchConfirm}
					onSearchChange={this.props.onMediaSearchChange}
					onNextPageRequest={this.props.onMediaSearchNextPageRequest}
					onSearchSelection={this.props.onMediaSearchSelection}
					searchTextValue={this.props.gifSearchTextValue}
					results={this.props.gifSearchResults}
					active={this.props.gifSearchActive}
					selected={this.props.gifSearchSelected}
					showMore={this.props.gifShowMore}
					message={this.props.gifMessage}
					title={this.props.gifTitle}
					hint={this.props.gifHint}
					multiselect={this.props.multiselect}
					placeholder={localize('picker_gif_search_placeholder')}
					source='gif'
				/>
				{!this.props.gifSearchActive &&
				<div styleName='file-selection'>
					<div styleName='drag-and-drop'>
						<DragPicker
							onChange={this.props.onFilesPicked}
							accept={this.props.accept}
							pickerType={this.props.pickerType}
							dropRejectedHandler={this.props.onFileError}
							multiselect={this.props.multiselect} />
					</div>
					<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
					<NearpodPickerOptions
						onFilesPicked={this.props.onFilesPicked}
						onFileError={this.props.onFileError}
						multiselect={this.props.multiselect}
						accept={this.props.accept} />
				</div>}
				<NearpodPickerBottomBar
					cancelText={this.props.gifSearchActive?localize('global_back'):localize('global_cancel')}
					cancelHandler={this.cancelHandler}
					saveHandler={this.saveHandler}
					saveButtonEnabled={!!this.props.gifSearchSelected.length} />
			</div>
		)
	}
}

export default MediaSearch(CSSModules(NearpodPickerGif, styles, {allowMultiple: true}))
